import React from "react";
import { Button } from "react-bootstrap";
import SecondaryParticipant from "./SecondaryParticipant";
import leftarrow from "../assets/images/leftarrow.svg";
const { REACT_APP_STATIC_ASSETS_BASE_URL } = process.env;

class ConferenceParticipantDetails extends React.Component {
  constructor(props) {
    super(props);
  }

  componentWillUnmount() {
    const { alterButtonDiableProperty, toggleDisplayPrimaryActionButton } =
      this.props;
    alterButtonDiableProperty(false);
    toggleDisplayPrimaryActionButton(true);
  }

  render() {
    const {
      callElement,
      removeParticipant,
      conn,
      toogleParticipantComponent,
      user,
      alterButtonDiableProperty
    } = this.props;
    return (
      <div>
        <div className="mainboxheader">
          <Button
            className="removecolorbut confrecall"
            onClick={() => {
              toogleParticipantComponent();
            }}
          >
            <div className="contactuslist">
              <img alt="" src={`${REACT_APP_STATIC_ASSETS_BASE_URL}${leftarrow}`} />
              <h4>Conference Call</h4>
            </div>
          </Button>
        </div>
        {callElement.conference.participants &&
          callElement.conference.participants.map(
            (participantElement, index) =>
              !["source", "destination"].includes(participantElement.type) &&
              participantElement.callStatus === "in-progress" && (
                <SecondaryParticipant
                  callElement={callElement}
                  participantElement={participantElement}
                  removeParticipant={removeParticipant}
                  key={`cp-${index}`}
                  conn={conn}
                  user={user}
                  alterButtonDiableProperty={alterButtonDiableProperty}
                />
              )
          )}
      </div>
    );
  }
}

export default ConferenceParticipantDetails;
